import { render, staticRenderFns } from "./SocialMediaShare.vue?vue&type=template&id=2d7f00e4&scoped=true&"
import script from "./SocialMediaShare.vue?vue&type=script&lang=js&"
export * from "./SocialMediaShare.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaShare.vue?vue&type=style&index=0&id=2d7f00e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7f00e4",
  null
  
)

export default component.exports